import { Chip, Divider } from "@mui/material";
import "../../css/index.css"

const DividerCustom = (props) => {

    const {
        txt = "",
        textAlign = "left",
        isChip = true,
        className = ""
    } = props;

    return (
        <Divider textAlign={textAlign}>
            {isChip ?
                <Chip className={className} label={txt} />
                :
                txt
            }

        </Divider>
    )
}
export default DividerCustom;